<template>
  <div>
    <!-- :btnCreate="true" -->
    <PageTitle
      title="Rate Types"
      :btnCreate="true"
      :createPopup="true"
      @onClickCreate="createRoomRateType()"
      :permission="'Cheques Index'"
    />
    <v-container fluid class="lighten-12 container">
      <v-card class="lighten-12 card-content">
        <TableFilters
          :filters="[ 'search']"
          v-model="filter"
          :columns="columns"
        ></TableFilters>
      </v-card>
      <v-card class="lighten-12 mt-2">
        <v-container fluid class="light gray lighten-12">
          <ValidationObserver ref="observer">
            <v-row>
              <v-card-text class="pa-0">
                <v-data-table
                  :items-per-page="paginationOptions.perPage"
                  :headers="headers"
                  :items="roomTypeList"
             
                  hide-default-footer
                  item-class="test2"
                >
                
                  <template v-slot:no-data>
                    <div class="mt-16 container justify-center item-center">
                      <noData name="Order" />
                    </div>
                  </template>

                   

                

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      :x-small="true"
                      class="ma-2"
                      label
                      text-color="white"
                      :color="getStatusColor(item.is_active)"
                      dark
                      >{{ item.is_active?'active':'archieved' }}</v-chip
                    >
                  </template>
                  <template v-slot:item.action="{ item }">
                    <list-menu
                      feature="room-type"
                      :item="item"
                      editPermission="Cheques Index"
                      @refreshList="refreshData"
                      @onEditClicked="editRoomRateType(item)"
                      :isEditModal="true"
                    ></list-menu>
                  </template>
                  <template v-slot:footer>
                    <pagination
                      @paginationOptions="setPaginationOptions"
                      @response="receiveRoomTypes"
                      url="hms/rate-types"
                      :filter="filter"
                      ref="pagination"
                    />
                  </template>
                </v-data-table>
              </v-card-text>
            </v-row>
          </ValidationObserver>
        </v-container>
      </v-card>
    </v-container>
    <ChequeDetails ref="refChequeDetails" @onClose="onClose" />
    <RateTypeCreate
      @conform="conform()"
      @afterSave="refreshData()"
      ref="refcreateRoomType"
    />

    <RateTypeEdit
      @close="AddWarehouse($event)"
      @conform="conform()"
      @afterSave="refreshData()"
      :rateType="rateType"
      :roomTypes="roomTypes"
      ref="refEditRoomType"
    />
  </div>
</template>
<script>
import noData from "@/components/shared/noItem";
import TableFilters from "@/components/base/TableFilters";
import pagination from "../../shared/components/pagination";
import RateTypeCreate from './RateTypeCreate.vue';
import RateTypeEdit from './RateTypeEdit.vue';
import RateTypeList from "./RateTypeList.vue";
import axios from "@/plugins/axios";
import { RateType } from '../../../models/RateType';
import _ from "lodash";
export default {
  data: () => ({
    paginationOptions: {},
    roomTypes:[],
    clonedRoomType:[],
    columns: [
      {
        text: "Name",
        value: "name",
        show: true,
        disabled: false,
        width: "10%",
      },
      {
        text: "Code",
        value: "code",
        show: true,
        disabled: true,
        width: "10%",
      },
       {
        text: "status",
        value: "status",
        show: true,
        disabled: true,
        width: "10%",
      },
      
      {
        text: "Action",
        value: "action",
        show: true,
        disabled: true,
        align: "center",
        width: "10%",
      },
    ],
    roomTypeList: [],
         rateType :RateType,
    filter: {
      invoice_status: "",
      start: "",
      end: "",
      amount: "",
      supplier: "",
      search: "",
      status: "",
    },
  
  }),
  
  components: {
    pagination,
    noData,
    TableFilters,
    RateTypeCreate,
    RateTypeEdit,RateTypeList
  },
  computed: {
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },

  },
  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    sumField(array, filed) {
      let value = 0;
      array.forEach((element) => {
        value += parseFloat(element[filed]);
      });
      return value;
    },
    onClose() {
      this.$refs.pagination.refreshData();
    },
     refreshData() {
      this.$refs.pagination.refreshData();
    },
    receiveRoomTypes(data) {
      this.roomTypeList = data;
    },
    viewCheque(chequeId) {
      this.$refs.refChequeDetails.openModal(chequeId);
    },
    createRoomRateType() {
      this.$refs.refcreateRoomType.openModal();
    },
    async editRoomRateType(cheque) {
      await this.GetRoomTypes();
      axios
        .get(`hms/rate-types/${cheque.id}`)
        .then((res) => {
          this.rateType =new RateType().toViewModel( res.data);
          this.rateType.roomTypes.map(p=>{
           let roomType= this.roomTypes.find(r=>r.id==p.id)
            if(this.rateType.roomTypes && roomType)
            {
            roomType.room_type_id=p.id;
            roomType.rack_rate=p.rack_rate;
            roomType.extra_adult=p.extra_adult;
            roomType.extra_child=p.extra_child;
            }
          })
        })
        .catch((err) => {});
      this.$refs.refEditRoomType.openModal(cheque.id);
    },
     GetRoomTypes() {
      axios
        .get(`hms/room-types`)
        .then((res) => {
          this.roomTypes =res.data.data;
          this.clonedRoomType=_.cloneDeep(  this.roomTypes)
        })
        .catch((err) => {});
    },
  
    conform() {
      this.$refs.pagination.fetchData();
    },
    getDateValidation(d) {
      var date = new Date(d);
      date.setDate(date.getDate() - 1);

      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      // Add a day
      // date.setDate(date.getDate() + 1)

      let yesterDay = new Date();
      yesterDay.setHours(0);
      yesterDay.setMinutes(0);
      yesterDay.setSeconds(0);

      console.log(date);
      console.log(yesterDay);
      if (date.getTime() <= yesterDay.getTime()) {
        return true;
      } else {
        return false;
      }
    },

    getStatusColor(status) {
      
      if(status)
      {
        return 'green'
      }
      else{
       return 'gray'
      }
    },
  },
  created() {
          this.GetRoomTypes();

    // this.$refs.refChequeDetails.openModal();
    // this.getPendingCheques();
  },
  watch: {},
  filters: {},
};
</script>




